import React from "react";
import { Box, Skeleton, Stack } from "@chakra-ui/react";

const LoadingState = () => {
  return (
    <Box>
      <Stack spacing={3}>
        <Skeleton height="40px" />
        <Skeleton height="120px" />
        <Skeleton height="280px" />
      </Stack>
    </Box>
  );
};

export default LoadingState;
